import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import { updateWindowValue } from "../functions/updateWindowValue";
import { colors } from "../../../data/colors";
import { openLangInfo } from "../functions/language/openLangInfo";

export const langModal = ({
  t,
  modalData,
  windowValues,
  setMsg,
  setModalData,
  setWindowValues,
  windowValues2,
  setWindowValues2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  return {
    title: modalData.title,
    inputs:
      "inputs" in modalData &&
      "data" in windowValues &&
      modalData.inputs.map((e: [string, string]) => {
        return {
          label: t(`l.${e[1]}`),
          value: windowValues.data[Number(e[0])]?.text ?? "",
          type: "text",
          style: { width: 300 },
          onChange: (o: { target: { value: SetStateAction<string> } }) =>
            updateWindowValue({
              key: "data",
              code: e[0],
              field: "text",
              value: o.target.value,
              windowValues,
              setWindowValues,
              windowValues2,
              setWindowValues2,
            }),
        };
      }),
    buttons: [
      {
        label: t("p.update"),
        onClick: () =>
          openLangInfo({}, true, {
            windowValues,
            setMsg,
            setModalData,
            setWindowValues,
            closeMsg,
            logoutAction,
          }),
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: () => closeMsg(),
        color: colors.darkGrey,
      },
    ],
  };
};
